import { render, staticRenderFns } from "./LandingBussinessBtns.vue?vue&type=template&id=6723c078&"
import script from "./LandingBussinessBtns.vue?vue&type=script&lang=js&"
export * from "./LandingBussinessBtns.vue?vue&type=script&lang=js&"
import style0 from "./LandingBussinessBtns.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports